import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { DocumentSpecifiqueDto } from 'lib_api/lib/api/gen';

import ResponsiveContainer from 'components/ResponsiveContainer';
import DocumentSpecifiqueCards from 'components/Tutorial/DocumentSpecifiqueCards/DocumentSpecifiqueCards';
import { useModal } from 'hooks/modal/useModal';
import useDeleteDocumentSpecifique from 'hooks/referentiels/DocumentSpecifique/useDeleteDocumentSpecifique';

import ModalCreate from './ModalCreate';
import ModalDelete from './ModalDelete';

import './index.less';

const DocumentsSpecifique: React.FC = () => {
  const [documentToDelete, setDocumentToDelete] = React.useState<
    DocumentSpecifiqueDto | undefined
  >(undefined);

  const [lastModificationDate, setLastModificationDate] = React.useState<
    number | undefined
  >(undefined);

  const [lastDeletionDate, setLastDeletionDate] = React.useState<
    number | undefined
  >(undefined);

  const modalCreation = useModal();
  const modalDelete = useModal();
  const { close: closeModalCreation, visible: modalCreationVisible } =
    modalCreation;
  const { close: closeModalDelete, visible: modalDeleteVisible } = modalDelete;

  useDeleteDocumentSpecifique(
    documentToDelete,
    lastDeletionDate,
    setLastModificationDate,
    modalDelete.close,
  );

  function onSuccess(lastModificationDate: number) {
    setLastModificationDate(lastModificationDate);
  }

  function handleDeleteModal(document: DocumentSpecifiqueDto) {
    setDocumentToDelete(document);
    modalDelete.open();
  }

  return (
    <ResponsiveContainer className="DocumentSpecifique-page">
      <h1>Gestion des documents spécifiques</h1>
      <AntdButton
        icon={<PlusOutlined />}
        type={'primary'}
        shape={'round'}
        onClick={modalCreation.open}
      >
        Importer un document spécifique
      </AntdButton>
      <ModalCreate
        close={closeModalCreation}
        visible={modalCreationVisible}
        onSuccess={onSuccess}
      />
      <ModalDelete
        close={closeModalDelete}
        visible={modalDeleteVisible}
        onConfirm={() => setLastDeletionDate(Date.now())}
        document={documentToDelete}
      />
      <div className="DocumentSpecifique-container">
        <DocumentSpecifiqueCards
          isAdmin
          lastModificationDate={lastModificationDate}
          onDelete={handleDeleteModal}
        />
      </div>
    </ResponsiveContainer>
  );
};

export default DocumentsSpecifique;
